module.exports = __webpack_public_path__ + "img/clap-bordered-colored-icon.38af87eb.svg";